<template>
    <div class="table-container">
        <div class="actions-tab in-tab">
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                    <div class="btn-download">
                        <div>
                  <span class="left">
                      <i class="icon icon-download"></i> {{setText('download')}}
                  </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <template v-if="filteredApps && filteredApps.length">
                    <b-dropdown-item
                        v-for="app in filteredApps"
                        :key="app.id + '_' + app.code"
                        class="text-left"
                        @click="downloadApplication(app.id)"
                    >
                        {{ appText(app) }}
                    </b-dropdown-item>
                </template>
                <b-dropdown-item class="text-left" v-if="selectedAlteration && ((['005.002.007', '005.002.003', '005.002.002'].includes(accessLevels.modules) && ['abp', 'uf', ''].includes(accessLevels.position)) || (['005.002.001'].includes(accessLevels.modules) && ['ipf'].includes(activeTab)) && ['abp', 'uf'].includes(accessLevels.position))" @click="downloadFile('SVI_IPF_PO')">{{setText('svi_ipf_obl')}}</b-dropdown-item>
                <b-dropdown-item class="text-left" v-if="selectedAlteration && ((['005.002.007', '005.002.003', '005.002.002'].includes(accessLevels.modules) && ['abp', 'uf', ''].includes(accessLevels.position)) || (['005.002.001'].includes(accessLevels.modules) && ['ipf'].includes(activeTab)) && ['abp', 'uf'].includes(accessLevels.position))" @click="downloadFile('SVI_IPF_PP')">{{setText('svi_ipf_pay')}}</b-dropdown-item>
                <b-dropdown-item class="text-left" v-if="selectedAlteration && accessLevels.modules === '005.002.002' && activeTab === 'uf'" @click="downloadFile('SVI_SPF_PO')">{{setText('svi_spf_obl')}}</b-dropdown-item>
                <b-dropdown-item class="text-left" v-if="selectedAlteration && accessLevels.modules === '005.002.002' && activeTab === 'uf'" @click="downloadFile('SVI_SPF_PP')">{{setText('svi_spf_pay')}}</b-dropdown-item>
                <b-dropdown-item class="text-left" v-if="selectedAlteration && accessLevels.modules === '005.002.002' && activeTab === 'uf'" @click="downloadReferenceExpenses()">{{setText('svi_spf_reference')}}</b-dropdown-item>
                <b-dropdown-item class="text-left" v-if="selectedAlteration && accessLevels.modules === '005.002.008' && !activeTab" @click="downloadFile('SVI_SP_PB')">{{setText('svi_spp')}}</b-dropdown-item>
                <b-dropdown-item class="text-left" v-if="[1].includes(tabIndex) && accessLevels.position === 'abp' && currAbp && [261, 360].includes(currAbp.abp)" @click="downloadVerifyReport(1)">{{setText('downloads.rep261_ga')}}</b-dropdown-item>
                <b-dropdown-item class="text-left" v-if="[1].includes(tabIndex) && accessLevels.position === 'abp' && currAbp && [261, 360].includes(currAbp.abp)" @click="downloadVerifyReport(0)">{{setText('downloads.rep261')}}</b-dropdown-item>
            </b-dropdown>
            <b-dropdown variant="link" class="info" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-info"></i>
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-text>
                    <div class="info-button" v-if="accessLevels.position === 'ipf'">
                        <span @click="infoModule(30, 'Инструкция пользователя Заявки ГУ')">{{setText('request_ga')}}<i
                            class="icon icon-folder"></i></span>
                    </div>
                    <div class="info-button"  v-if="[1].includes(tabIndex)">
                        <a href="https://youtu.be/O1E_lZr26WU" target="_blank"><span>{{setText('video_instructions.filling')}}<i
                            class="icon icon-video"></i></span></a>
                        <a href="https://www.youtube.com/watch?v=iP1UBQvBvfA" target="_blank"><span>{{setText('video_instructions.questions')}}<i
                            class="icon icon-video"></i></span></a>
                        <a href="https://www.youtube.com/watch?v=lFoY3fKLUVk&ab_channel=eAkimat365" target="_blank"><span>{{setText('video_instructions.import')}}<i
                            class="icon icon-video"></i></span></a>
                    </div>
                    <div class="info-button"  v-if="[2, 3].includes(tabIndex)">
                        <a href="https://youtu.be/O1E_lZr26WU" target="_blank"><span>{{setText('video_instructions.filling')}} <i
                            class="icon icon-video"></i></span></a>
                        <a href="https://www.youtube.com/watch?v=lFoY3fKLUVk&ab_channel=eAkimat365" target="_blank"><span>{{setText('video_instructions.import')}}<i
                            class="icon icon-video"></i></span></a>
                        <a href="https://www.youtube.com/watch?v=f3Wqet3K6Ck&ab_channel=eAkimat365" target="_blank"><span>{{setText('video_instructions.abp')}}<i
                            class="icon icon-video"></i></span></a>
                        <a href="https://www.youtube.com/watch?v=IcYjD_b5zW0&ab_channel=eAkimat365" target="_blank"><span>{{setText('video_instructions.abp_ind')}}<i
                            class="icon icon-video"></i></span></a>
                    </div>
                    <div class="info-button" v-if="[3,4].includes(tabIndex)">
                        <a href="https://www.youtube.com/watch?v=0Cm0Ad26CPw&ab_channel=eAkimat365" target="_blank"><span>{{setText('video_instructions.uo')}}<i
                            class="icon icon-video"></i></span></a>
                    </div>
                    <div class="info-button" v-if="[5].includes(tabIndex)">
                        <a href="https://youtu.be/85zV-RncDdY" target="_blank"><span>{{setText('video_instructions.income')}}<i
                            class="icon icon-video"></i></span></a>
                    </div>
                    <div class="info-text" v-if="accessLevels.position === 'ipf'">
                        <p>{{setText('video_instructions.about')}}</p>
                    </div>
                </b-dropdown-text>
            </b-dropdown>
        </div>
        <table class="table b-table table-bordered b-table-no-border-collapse">
            <thead>
            <tr>
                <th>№</th>
                <th v-if="(accessLevels.editAccess && [1, 3].includes(tabIndex) && (['abp', 'uf'].includes(accessLevels.position)) && (roleIncludes('abp_agree') || roleIncludes('uf_edit'))) && levelsCheck && checkInVisible">
                    <div class="text-center">
                        <b-form-checkbox
                            v-if="checkInVisible && checkVisible && accessLevels.editAccess && !isAbp123"
                            v-model="selectAll"
                            @change="e => setIsAllDelete(e)"
                            :value="true"
                            :unchecked-value="false" />
                    </div>
                </th>
                <th>{{setText('name')}}</th>
                <th>{{setText('date')}}</th>
                <th>{{setText('status')}}</th>
                <th>{{setText('base')}}</th>
                <th>{{setText('comment')}}</th>
                <th>{{setText('user')}}</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <template v-for="row of requestsBase">
                <tr :key="row.id" @click="downloadApp(row)" :class="{ 'selected_row': row.selected }" style="cursor: pointer;">
                    <td>{{ row.number }}</td>
                    <td v-if="(['abp', 'uf'].includes(accessLevels.position)  && (roleIncludes('abp_agree') || roleIncludes('uf_edit'))) && levelsCheck && checkInVisible && accessLevels.editAccess && [1, 3].includes(tabIndex)">
                        <b-form-checkbox v-if="row.checking" v-model="row.check" @change="onChecked($event, row)"
                                         @input="e => { onInput(e) }"></b-form-checkbox></td>
                    <td :id="'app-name-' + row.id"
                        @contextmenu.prevent="showContextMenu($event, row.id)"
                        @mouseleave="hidePopoverDelayed"
                        @mouseenter="cancelHidePopover(row.id)">
                        <a href="#" @click="rowOpen(row)">
                            {{ getFullName(row) }}
                        </a>
                        <b-popover v-if="showId" :target="'app-name-' + row.id" :show="activePopoverId === row.id" triggers="manual" placement="top" :delay="{ show: 150, hide: 400 }">
                            <div style="display: flex; align-items: center;" @mouseenter="cancelHidePopover(row.id)" @mouseleave="hidePopoverDelayed">
                                <span style="margin-right: 8px;">ID: {{ row.id }}</span>
                                <b-button size="sm" variant="outline-primary" style="padding: 2px 5px; font-size: 12px;" @click.stop.prevent="copyId(row.id); activePopoverId = null">
                                    {{setText('copy')}}
                                </b-button>
                            </div>
                        </b-popover>
                    </td>
                    <td>{{ row.date | formatDate }}</td>
                    <td v-if="('status' in row && row.status !== null && (row.childStatus === undefined || !row.childStatus))" style="text-align: center;">{{ getLocalStatus(row) }}
                        <span class="doc-icon" v-if="row.parent !== null">
                    <img
                        href="#"
                        onerror="this.style.display = 'none'"
                        :src="getIcon()"
                        alt="icon"
                        :id="'parent-id-icon'+row.id"
                        ref="roPar"
                        @click="show = !show"
                        style="width: 20px; height: 20px"
                    />
                    <b-tooltip :target="'parent-id-icon'+row.id" :show="show" variant="info" v-if="row.parentInfo !== undefined"> # {{ row.parentInfo.number }} от ( {{ row.parentInfo.date | formatDate }} )</b-tooltip>
                </span>
                    </td>
                    <td v-else-if="('status' in row && row.status !== null && row.childStatus)"  style="text-align: center; color: red" :id="'status-bug-child'+row.id">{{ getLocalStatus(row) }}
                        <span class="doc-icon" v-if="row.parent !== null">
                    <img
                        href="#"
                        onerror="this.style.display = 'none'"
                        :src="getIcon()"
                        alt="icon"
                        :id="'parent-id-icon'+row.id"
                        ref="roPar"
                        @click="show = !show"
                        style="width: 20px; height: 20px"
                    />
                    <b-tooltip :target="'parent-id-icon'+row.id" :show="show" variant="info" v-if="row.parentInfo !== undefined"> # {{ row.parentInfo.number }} от ( {{ row.parentInfo.date | formatDate }} )</b-tooltip>
                </span>
                    </td>
                    <!--            <b-tooltip :target="'status-bug-child'+row.id" :show="showStatus" variant="danger" v-if="row.childStatus"> Необходимо утвердить заявки АБП: <br> {{row.numberArr}} </b-tooltip>-->
                    <td>
                        <div>{{ row.description }}</div>
                        <div v-for="file of row.fileList" :key="file.id">
                            <a href="#" @click="() => downloadLink(file)">
                              <span class="doc-icon">
                                  <img
                                      onerror="this.style.display = 'none'"
                                      :src="getLink(file.name)"
                                      alt="icon"
                                  />
                              </span>
                                            {{ file.name }}
                            </a>
                        </div>
                    </td>
                    <td v-if="row.status">{{ row.status.comment }}</td>
                    <td v-else></td>
                    <td>{{ row.userName }}</td>
                    <td>
                        <b-dropdown dropleft class="more-dropdown">
                            <template v-slot:button-content>
                                <i class="icon icon-more"></i>
                            </template>
                            <template>
                                <b-dropdown-item-btn @click="() => {onChange(row);}"
                                                     v-if="haveEditAccess(row) && accessLevels.editAccess && haveEditAccessAbp(row)">
                                    <i class="icon icon-pencil-edit"></i>{{setText('edit')}}
                                </b-dropdown-item-btn>
                                <b-dropdown-item-btn @click="() => {onRequestAdd(row);}"
                                                     v-if="haveEditAccess(row) && accessLevels.editAccess && ![1, 5].includes(tabIndex) && canEditBasisField(row)">
                                    <img
                                        :src="getIcon()"
                                        alt="icon"
                                        style="width: 20px; height: 20px"
                                    />   {{setText('add_request')}}
                                </b-dropdown-item-btn>
                                <b-dropdown-item-btn @click="() => {onDelete(row);}"
                                                     v-if="haveEditAccess(row) && accessLevels.editAccess && canEditBasisField(row)"
                                ><i class="icon icon-close" style="color: red;"></i>
                                    <span  style="color: red;">  {{setText('delete')}}</span>
                                </b-dropdown-item-btn>
                                <b-dropdown-item-btn @click="openHistory(row)">{{setText('history')}}</b-dropdown-item-btn>
                            </template>
                        </b-dropdown>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>
        <alteration-add-modal
            @shown="showAddModal = false"
            :show="showAddModal"
            :table-data="requestData"
            :requestId="requestId"
            :tabIndex="tabIndex"
            @reLoad="onReLoad"
        ></alteration-add-modal>
        <b-exec-agr-hist-modal ref="refHistModal" :status-types="statusType" :with-time="true"/>
    </div>
</template>


<script>
import {Ax} from "@/utils";
import axios from "axios";
import alterationAddModal from "./alterationAddModal";
import store from "@/services/store";
import moment from "moment";
import BExecAgrHistModal from "@/modules/budget/execution/form/tabs/components/BExecAgrHistModal";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";
import i18nService from "@/services/i18n";

export default {
    data() {
        return {
            activePopoverId: null,
            hidePopoverTimer: null,
            check: false,
            selectedAlteration: null,
            checkButton: 0,
            selectAll: false,
            checkCount: 0,
            currentRequest: null,
            show: false,
            showStatus: false,
            currentParent: [],
            checkVisible: false,
            showAddModal: false,
            requestData: [],
            requestId: null,
            requestLevel: null,
            appsList: [],
            userRole: null,
        };
    },
    components: { 'alteration-add-modal': alterationAddModal, 'b-exec-agr-hist-modal': BExecAgrHistModal },
    mixins: [ AlterationI18nMixin ],
    props: {
        guBase: null,
        currAbp: null,
        requestsBase: {},
        accessLevels: {},
        levelsCheck: {},
        requestTypeOptions: {},
        statusType: {},
        activeTab: null,
        incTab: {},
        editAccessStatusList: {},
        tabIndex: {},
        verifyReport: {},
        dateTo: {},
        currRegion: {},
        tabCode: {},
        isLoadToJournalEnabled: {},
        isTransfert: {},
        showId: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        showContextMenu(e, id) {
            if (!this.showId) return;
            if (this.hidePopoverTimer) {
                clearTimeout(this.hidePopoverTimer);
            }
            this.activePopoverId = id;
        },
        hidePopoverDelayed() {
            // Добавляем задержку в 400мс, чтобы дать возможность навести мышь на сам поповер
            this.hidePopoverTimer = setTimeout(() => {
                this.activePopoverId = null;
            }, 400);
        },
        cancelHidePopover(id) {
            // Отменяем закрытие поповера, если мышь вернулась обратно на элемент или на сам поповер
            if (this.activePopoverId === id && this.hidePopoverTimer) {
                clearTimeout(this.hidePopoverTimer);
            }
        },
        hidePopover(e) {
            if (this.activePopoverId) {
                // Игнорируем клик внутри самого popover
                if (e && e.target && typeof e.target.closest === 'function' && e.target.closest('.popover')) return;
                this.activePopoverId = null;
            }
        },
        haveEditAccess: function (row) {
            const basicConditions = ('status' in row && row.status !== null && this.editAccessStatusList.includes(row.status.status) && this.incTab
                && (this.roleIncludes('gu_edit') || this.roleIncludes('uf_edit') || this.roleIncludes('abp_agree'))
                && !([2, 3].includes(this.tabIndex) && this.roleIncludes('abp_educ')));

            if (!basicConditions) {
                return false;
            }

            // Если статус 32, проверяем наличие parent
            if (row.status && row.status.status === 32) {
                return row.parent !== null;
            }
            // Для всех остальных статусов из editAccessStatusList возвращаем true
            return true;
        },
        haveDeleteAccess(row) {
            return 'status' in row && row.status !== null && [1].includes(row.status.status) && this.roleIncludes('gu_edit')
        },
        checkInVisible() {
            return this.checkCount > 0;
        },
        roleIncludes(val){

            let ed = 0;
            if (this.accessLevels && this.accessLevels.operations) {
                this.accessLevels.operations.forEach((op, ind) => {
                    if (op.toLowerCase().lastIndexOf(val) !== -1) {
                        ed += 1;
                    }
                });
            }
            return ed > 0
        },
        async setUserRole() {
            const response = await fetch(`/api-py/alteration/journal/user-role/${this.userUiid}`)
            if (!response.ok) {
                this.makeToast('danger', 'Ошибка', 'Не удалось определить роль пользователя')
                throw new Error('Ошибка загрузки роли пользователя')
            }
            const responseBody = await response.json()
            this.userRole = responseBody.role
        },
        getFullName(row) {
            if (!this.requestTypeOptions || !this.requestTypeOptions.length) return;
            const curType = this.requestTypeOptions.filter((item) => item.code === row.requestType);
            if (!curType || !curType.length) return;
            this.nameLocale(curType);
            const localName = curType[0]["name_" + this.$i18n.locale];
            // eslint-disable-next-line
            // @ts-ignore
            if (row.level === 'abp' && row.localText === undefined) {
                // this.$set(row, 'localText', row.abp + ' - abp');

                Object.defineProperty(row, 'localText', {
                    configurable: true,
                    get: function () {
                        return row.abp + ' - abp';
                    }
                });
            }
            if (row.level !== 'uf' && this.levelsCheck) {
                return `${localName} ${row.localText}`;
            } else {
                return `${localName}`;
            }
        },
        getLocalStatus(value) {
            const status = value.status.status;
            if (!this.statusType || !this.statusType.length) return status;
            const curStatus = this.statusType.filter((item) => item.code === status);
            if (!curStatus || !curStatus.length) return status;
            return curStatus[0]["name_" + this.$i18n.locale];
        },
        getLink(name) {
            if (!name) return "";
            const extn = name.match(/\.([^.]+)$/)?.[1];
            let fileType = null;
            if (extn && ["doc", "docx"].includes(extn)) fileType = "word";
            if (extn && ["csv", "xls", "xlsx"].includes(extn)) fileType = "excel";
            if (extn && ["pdf"].includes(extn)) fileType = "pdf";
            if (!fileType) return "";
            return `img/svg-icons/${fileType}.svg`;
        },
        getIcon() {
            return `img/svg-icons/merge4.svg`;
        },
        async rowOpen(row) {
            if (Array.isArray(this.guBase) && this.guBase.length > 0) {
                this.guBase.forEach(item => {
                    if (item.code === row.gu) {
                        this.$emit('editCurrentGu', item)
                    }
                })
            }
            this.onOpen(row);
            if (row.parent !== null) {
                this.loadParent(row);
            }
        },
        onChange(item){
            this.$emit('onChange', item);
        },
        onChecked (e, row) {
            if ([1].includes(this.tabIndex) && (e && row && String(row.abp) === '123')) {
                this.requestsBase.forEach(item => {
                    if (item.checking && item.id !== row.id && item.check) {
                        this.$set(item, 'check', false);
                    }
                });
            }
            this.$nextTick(() => {
                let count = 0;
                if (Array.isArray(this.requestsBase)) {
                    this.requestsBase.forEach(item => {
                        if (item.checking && item.check) {
                            count++;
                        }
                    });
                }
                this.checkButton = count;
                this.$emit('onChecked', this.checkButton);
                this.selectAll = this.checkCount === this.checkButton && this.checkCount > 0;
            });
        },
        onInput (e) {
            if (!e) this.selectAll = false;
        },
        downloadApp(item) {
            for (const r of this.requestsBase) {
                r.selected = false;
            }
            this.selectedAlteration = item;
            item.selected = !item.selected;
            if (item.parent !== null) {
                this.loadParent(item);
            }
            this.loadApplicationsTitle();
        },
        setIsAllDelete(val, data = this.requestsBase) {
            if (this.checkButton !== this.checkCount) { this.checkButton = 0; }
            data.forEach(item => {
                if (item.checking) {
                    this.$set(item, 'check', val);
                    this.onChecked(val);
                }
            });

        },
        async getUser261GuList(userId) {
            try {
                const response = await fetch(`/api-py/alteration/journal/gu261/${userId}`)
                if (!response.ok) {
                    this.makeToast('danger', 'Ошибка', 'Ошибка загрузки ОО ГУ')
                    const errorData = await response.json().catch(() => null)
                    const errorText = await response.text().catch(() => 'No text')
                    console.error(`Error ${response.status}:`, errorData || errorText)
                    return []
                }
                const responseBody = await response.json()
                return responseBody.gu_list
            } catch (error) {
                console.error(error)
                return []
            }
        },
        async getUser261Workplace(userId) {
            try {
                const response = await fetch(`/api-py/alteration/journal/gu261-workplace/${userId}`)
                if (!response.ok) {
                    this.makeToast('danger', 'Ошибка', 'Ошибка загрузки рабочего места')
                    const errorData = await response.json().catch(() => null);
                    const errorText = await response.text().catch(() => 'No text');
                    console.error(`Error ${response.status}:`, errorData || errorText);
                    return null
                }
                const responseBody = await response.json()
                return responseBody.workplace || null
            } catch (error) {
                console.error(error)
                return null
            }
        },
        async downloadApplication(app) {
            const item = this.requestsBase.find(x => x.selected);
            const lang = this.$i18n.locale;
            const appDict = {
                1: '27',
                2: '28',
                3: '34',
                4: '36',
                5: '29',
                6: '30',
                7: '37',
                8: '39',
                9: '25',
                10: '26',
                11: '29(без ГУ)',
                12: '30(без ГУ)',
                13: '34(без ГУ)',
                14: '36(без ГУ)',
                15: '33',
                16: '35',
                17: '17',
                19: '19',
                20: '14',
                21: '15',
                22: '37(без ГУ)',
                23: '39(без ГУ)',
                24: '34(по учреждениям)',
                25: '36(по учреждениям)',
            }
            if (!item) {
                this.makeToast('warning', 'Сообщение', 'Не выбрана форма');
            } else {
                // Параметры для получения подписантов (общие для ALTER и ALTER2)
                const signParams = {
                    code_modules: this.accessLevels.modules,
                    region: item.region,
                    abp: item.abp,
                    code_gu: item.gu,
                    date_start_variants: moment(item.date).format('YYYY-MM-DD')
                }
                if (app < 17 || [22, 23, 24, 25].includes(app)) {
                    const year = new Date(item.date).getFullYear();
                    const date = moment(item.date).format('DD.MM.YYYY')
                    const appItem = this.appsList.find(x => x.id === app);
                    // EAK-1604 (ФТ-1.3/1.4): «Приложение 36/38 (по учреждениям)» выгружается в
                    // одном языковом варианте (не рус+каз, как старые пункты), поэтому имя файла
                    // и название записи журнала должны идти на языке интерфейса, а не всегда
                    // по-русски, как для остальных (действующих) пунктов списка.
                    const appDisplayName = ([24, 25].includes(app) && lang === 'kk')
                        ? (appItem.name_kz || appItem.name_ru)
                        : appItem.name_ru
                    let desc = ''
                    if (this.tabIndex === 1) {
                        desc = item.gu
                    } else if (this.tabIndex === 2) {
                        desc = item.abp
                    } else if (this.tabIndex === 3) {
                        desc = item.abp
                    } else if (this.tabIndex === 4) {
                        desc = item.region
                    } else if (this.tabIndex === 5) {
                        desc = item.region
                    }
                    const filename = `${appDisplayName}_${desc}_${item.number}_${date}.xlsx`
                    const d = {
                        'app': app,
                        'id': item.id,
                        'date': date,
                        'gu': item.gu,
                        'year': year,
                        'region': item.region,
                        'description': item.description,
                        'number': item.number,
                        'request_type': item.requestType,
                        'abp': item.abp,
                        'abp261gu': [],
                        'treeData': [],
                        'signers': signParams,
                        'level': item.level,
                        'name': appDisplayName,
                        'user_id': this.$store.getters.user_uuid,
                        'agreement_status': item.status.status,
                        'report_key': 'ALTER',
                        'source_tab': this.tabCode,
                        'isTransfert': this.isTransfert,
                        'filename': filename,
                        'lang': lang
                    }

                    if (this.userRole === 'OO' && ['requestABP', 'referenceABP'].includes(this.tabCode)) {
                        d.abp261gu = await this.getUser261GuList(this.userUiid)
                        d.gu261_code = await this.getUser261Workplace(this.userUiid)
                    }

                    if (this.isLoadToJournalEnabled) {
                        // Выгрузка в журнал
                        const response = await fetch('/api-py/alteration/journal', {
                            method: 'POST',
                            body: JSON.stringify(d)
                        })
                        if (!response.ok) {
                            this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                            return
                        }
                        const journalId = await response.text()
                        fetch(`/api-py/alteration/journal/${journalId}`, {
                            method: 'PUT'
                        })
                        this.makeToast('success', 'Внимание!', 'Началась выгрузка. Для скачивания отчета перейдите во вкладку "Журнал"')
                        this.$emit('reload-journal')
                    } else {
                        // Прямая выгрузка
                        Ax(
                            {
                                url: '/api-py/alteration_application/',
                                method: 'POST',
                                responseType: 'blob',
                                data: d
                            },
                            (data) => {
                                const filename = `${appDisplayName}_${desc}_${item.number}_${date}.xlsx`

                                const url = window.URL.createObjectURL(new Blob([data]));
                                const link = document.createElement('a');
                                link.href = url;
                                link.setAttribute('download', filename)
                                document.body.appendChild(link);
                                link.click();
                            },
                            (error) => {
                                this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                            }
                        )
                    }
                }
                else if (app > 16) {
                    if (app === 20) { app = 14 }
                    if (app === 21) { app = 15 }
                    const year = new Date(item.date).getFullYear();
                    const date = moment(item.date).format('DD.MM.YYYY')
                    const appItem = this.appsList.find(x => x.id === app);
                    const filename = this.setText('app') + ` ${app}_${item.region}_${year}.xlsx`
                    const d = {
                        'year': year,
                        'signers': signParams,
                        'region': item.region,
                        'abp': null,
                        'prg': null,
                        'ppr': null,
                        'spf': null,
                        'kat': null,
                        'cls': null,
                        'pcl': null,
                        'app': app,
                        'treeData': [],
                        'user_id': this.$store.getters.user_uuid,
                        'location': 0,
                        'status': null,
                        'level': item.level,
                        'name': appItem.name_ru,
                        'report_key': 'ALTER2',
                        'source_tab': this.tabCode,
                        'agreement_status': item.status.status,
                        'request_type': item.request_type,
                        'date': date,
                        'isTransfert': this.isTransfert,
                        'filename': filename
                    }

                    // name += `_${desc}_${item.number}_${date}.xlsx`

                    if (this.isLoadToJournalEnabled) {
                        // Выгрузка в журнал
                        const response = await fetch('/api-py/alteration/journal', {
                            method: 'POST',
                            body: JSON.stringify(d)
                        })
                        if (!response.ok) {
                            this.makeToast('danger', 'Ошибка запроса downloadApplication()', error.toString());
                            return
                        }
                        const journalId = await response.text()
                        fetch(`/api-py/alteration/journal/${journalId}`, {
                            method: 'PUT'
                        })
                        this.makeToast('success', 'Внимание!', 'Началась выгрузка. Для скачивания отчета перейдите во вкладку "Журнал"')
                        this.$emit('reload-journal')
                    } else {
                        // Прямая выгрузка
                        Ax(
                            {
                                url: '/api-py/get-budget-execution-report/',
                                method: 'POST',
                                responseType: 'blob',
                                data: d
                            },
                            (data) => {
                                const url = window.URL.createObjectURL(new Blob([data]));
                                const link = document.createElement('a');
                                link.href = url;
                                link.setAttribute('download', filename);
                                document.body.appendChild(link);
                                link.click();
                            },
                            (error) => {
                                this.makeToast('danger', 'Ошибка запроса downloadApplication()', error.toString());
                            }
                        )
                    }
                }
            }
        },
        async downloadFile(app) {
            if (this.isLoadToJournalEnabled) {
                // Выгрузка в журнал
                const appDict = {
                    'SVI_IPF_PO': this.setText('svi_ipf_obl'),
                    'SVI_IPF_PP': this.setText('svi_ipf_pay'),
                    'SVI_SPF_PO': this.setText('svi_spf_obl'),
                    'SVI_SPF_PP': this.setText('svi_spf_pay'),
                    'SVI_SP_PB': this.setText('svi_spp')
                }
                const item = this.requestsBase.find(x => x.selected);

                let params = {}
                if (app === 'SVI_IPF_PO') {
                    params = {
                        'type': 'OBLIGATION',
                        'requestId': item.id,
                        'planType': 'EXPENSE',
                        'addIpf': false,
                        'addAllAgreed': false,
                        'isLeftMonth': true,
                        'code': app
                    }
                } else if (app === 'SVI_IPF_PP') {
                    params = {
                        'type': 'PAYMENT',
                        'requestId': item.id,
                        'planType': 'EXPENSE',
                        'addIpf': false,
                        'addAllAgreed': false,
                        'isLeftMonth': true,
                        'code': app
                    }
                } else if (app === 'SVI_SPF_PO') {
                    params = {
                        'type': 'OBLIGATION',
                        'requestId': item.id,
                        'level': 'UF',
                        'dataLevel': 'PRG',
                        'planType': 'EXPENSE',
                        'addIpf': false,
                        'addAllAgreed': false,
                        'isLeftMonth': true,
                        'code': app
                    }
                } else if (app === 'SVI_SPF_PP') {
                    params = {
                        'type': 'PAYMENT',
                        'requestId': item.id,
                        'level': 'UF',
                        'dataLevel': 'PRG',
                        'planType': 'EXPENSE',
                        'addIpf': false,
                        'addAllAgreed': false,
                        'isLeftMonth': true,
                        'code': app
                    }
                } else if (app === 'SVI_SP_PB') {
                    params = {
                        'requestId': item.id,
                        'addSpp': false,
                        'addAllAgreed': false,
                        'planType': 'INCOME',
                        'code': app,
                    }
                }

                let desc = ''
                if (this.tabIndex === 2 || this.tabIndex === 3) {
                    desc = item.abp
                } else if (this.tabIndex === 4 || this.tabIndex === 5) {
                    desc = item.region
                }
                const date = moment(item.date).format('DD.MM.YYYY')
                const filename = `${appDict[app]}_${desc}_${item.number}_${date}.xls`

                const journalParams = {
                    sourceTab: this.tabCode,
                    region: item.region,
                    abp: item.abp,
                    gu: item.gu,
                    number: item.number,
                    requestType: item.requestType,
                    date: moment(item.date).format('YYYY-MM-DD'),
                    agreementStatus: item.status.status,
                    name: appDict[app],
                    parameters: params,
                    reportKey: 'BASE',
                    filename: filename
                }

                if (this.abp261gu?.code) {
                    journalParams.gu261 = this.abp261gu.code
                }
                if (this.userRole === 'OO' && ['requestABP', 'referenceABP'].includes(this.tabCode)) {
                    journalParams.gu261 = await this.getUser261Workplace(this.userUiid)
                }

                const initilizeResponse = await fetch('/api/alteration/journal', {
                    method: 'POST',
                    body: JSON.stringify(journalParams),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                if (!initilizeResponse.ok) {
                    this.makeToast('danger', 'Ошибка', 'Ошибка инициализации в журнал')
                    return
                }
                const entryId = await initilizeResponse.text()
                this.makeToast('success', 'Внимание!', 'Началась выгрузка. Для скачивания отчета перейдите во вкладку "Журнал"')

                fetch(`/api/alteration/journal/${entryId}`, {
                    method: 'POST',
                })

                this.$emit('reload-journal')
                return
            }

            // Прямая выгрузка
            try {
                const item = this.requestsBase.find(x => x.selected);
                if (app === 'SVI_IPF_PO') {
                    await axios.get(`api/budget-execution-base/xls?type=OBLIGATION&requestId=${item.id}&planType=EXPENSE&addIpf=false&addAllAgreed=false&isLeftMonth=true&code=${app}`, {responseType: 'blob'}).then(response => {
                        this.currentRequest = response.data
                    }).catch(error => {
                        console.log(error)
                        this.currentRequest = null
                    })
                }
                if (app === 'SVI_IPF_PP') {
                    await axios.get(`api/budget-execution-base/xls?type=PAYMENT&requestId=${item.id}&planType=EXPENSE&addIpf=false&addAllAgreed=false&isLeftMonth=true&code=${app}`, {responseType: 'blob'}).then(response => {
                        this.currentRequest = response.data
                    }).catch(error => {
                        console.log(error)
                        this.currentRequest = null
                    })
                }
                if (app === 'SVI_SPF_PO') {
                    await axios.get(`api/budget-execution-base/xls?type=OBLIGATION&requestId=${item.id}&level=UF&dataLevel=PRG&planType=EXPENSE&addIpf=false&addAllAgreed=false&isLeftMonth=true&code=${app}`, {responseType: 'blob'}).then(response => {
                        this.currentRequest = response.data
                    }).catch(error => {
                        console.log(error)
                        this.currentRequest = null
                    })
                }
                if (app === 'SVI_SPF_PP') {
                    await axios.get(`api/budget-execution-base/xls?type=PAYMENT&requestId=${item.id}&level=UF&dataLevel=PRG&planType=EXPENSE&addIpf=false&addAllAgreed=false&isLeftMonth=true&code=${app}`, {responseType: 'blob'}).then(response => {
                        this.currentRequest = response.data
                    }).catch(error => {
                        console.log(error)
                        this.currentRequest = null
                    })
                }
                if (app === 'SVI_SP_PB') {
                    await axios.get(`api/budget-execution-base/xls?requestId=${item.id}&addSpp=false&addAllAgreed=false&planType=INCOME&code=${app}`, {responseType: 'blob'}).then(response => {
                        this.currentRequest = response.data
                    }).catch(error => {
                        console.log(error)
                        this.currentRequest = null
                    })
                }
                const date = moment(item.date).format('DD.MM.YYYY')
                const appDict = {
                    'SVI_IPF_PO': this.setText('svi_ipf_obl'),
                    'SVI_IPF_PP': this.setText('svi_ipf_pay'),
                    'SVI_SPF_PO': this.setText('svi_spf_obl'),
                    'SVI_SPF_PP': this.setText('svi_spf_pay'),
                    'SVI_SP_PB': this.setText('svi_spp')
                }
                let name = appDict[app]
                let desc = ''
                if (this.tabIndex === 2 || this.tabIndex === 3) {
                    desc = item.abp
                } else if (this.tabIndex === 4 || this.tabIndex === 5) {
                    desc = item.region
                }
                name += `_${desc}_${item.number}_${date}.xls`

                if (this.currentRequest !== null) {
                    const url = window.URL.createObjectURL(new Blob([this.currentRequest], {type: 'application/xls'}));
                    const link = document.createElement('a');
                    link.href = url;
                    link.target = '_blank';
                    link.setAttribute('download', name);
                    link.click();
                } else {
                    this.makeToast('danger', this.setText('warning'), this.setText('flc.empty'));
                }
            } catch (error) {
                console.error(this.setText('errors.file'), error.toString());
                this.toast('danger', this.i18n.translate('error.cannot_load_files'), this.setText('flc.notfound'))
            }
        },
        // Справка (расходы) с примечаниями - пункт меню "Скачать" из СПИСКА справок (вкладка "Справки
        // (расходы)" УО), EAK-623. В отличие от того же пункта в открытой форме (newAlterationForm.vue::
        // downloadReferenceExpenses()), данные формы здесь в памяти не загружены - бэкенд сам собирает все
        // строки справки (и примечания) по requestId. Контракт - POST /api-py/alteration-reference-expenses-by-id/.
        downloadReferenceExpenses() {
            const item = this.selectedAlteration;
            if (!item) return;
            const lang = this.$i18n.locale;
            const dateForFilename = moment(item.date).format('DD.MM.YYYY');
            // Имя файла на языке выгрузки (EAK-623, замечание PM): ru - "Справка_№{number}_{date}",
            // kk - "№{number}_Анықтама_{date}" (тот же порядок слов, что в шапке самого отчёта).
            const filename = lang === 'kk'
                ? `№${item.number}_Анықтама_${dateForFilename}.xlsx`
                : `Справка_№${item.number}_${dateForFilename}.xlsx`;

            const payload = {
                requestId: item.id,
                lang: lang,
                number: item.number,
                date: moment(item.date).format('YYYY-MM-DD'),
                year: new Date(item.date).getFullYear(),
                abp: item.abp ?? null,
                gu: item.gu,
                region: item.region,
                requestType: item.requestType,
                budgetVersion: item.budgetVersion ?? null,
                level: item.level
            };

            Ax(
                {
                    url: '/api-py/alteration-reference-expenses-by-id/',
                    method: 'POST',
                    responseType: 'blob',
                    data: payload
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    this.makeToast('danger', this.setText('errors.request') + ' downloadReferenceExpenses()', error.toString());
                }
            );
        },
        onRequestAdd(item) {
            this.loadRequest(item);
            this.showAddModal = true;
        },
        async loadRequest(item) {
            this.requestId = item.id;
            this.requestLevel = item.level;
            const req = { requestId: item.id, level: item.level, region: item.region, abp: item.abp, user_id: this.userUiid };
            await axios.get('/api-py/get-consolidate-request-list/' + JSON.stringify(req)).then(response => {
                const currentYear = moment(item.date).year();

                this.requestData = response.data
                    .filter(item => moment(item.date).year() === currentYear)
                    .map(item => ({
                        ...item,
                        localText: this.getName(item),
                        date: moment(item.date).format('DD.MM.YYYY')
                    }));
            });
        },
        getName(row) {
            if (!this.requestTypeOptions || !this.requestTypeOptions.length) return;
            const curType = this.requestTypeOptions.filter((item) => item.code === row.request_type);
            if (!curType || !curType.length) return;
            const localName = curType[0]["name_" + this.$i18n.locale];
            // eslint-disable-next-line
            // @ts-ignore
            if (row.level === 'gu') {
                return `${localName} ${row.gu_name}`;
            } else if (row.level === 'abp') {
                return `${localName} ${row.abp_name}`;
            } else {
                return `${localName}`;
            }
        },
        chgData() {
            this.$emit('chgData', this.requestsBase);
        },
        onOpen(item){
            this.$emit('onOpen', item);
        },
        onDelete(item) {
            this.$emit('onDelete', item);
        },
        async downloadLink(file) {
            const that = this;
            Ax(
                {
                    url: '/api/budget-execution-alteration-request/file/' + file.id, //  Тело файла
                    data: null,
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.name);// or any other extension
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    that.error = error;
                    this.makeToast(
                        "danger",
                        this.setText("errors.download"),
                        error.toString()
                    );
                }
            );
        },
        async delete(item) {
            this.$set(item, 'form', this.form.code);
            try {
                this.$set(this.header, 'value', this.calcTotalForDelete(this.budgetForm, 'cost_total'));
                const response = await fetch('/api-py/delete-budget-request-form-with-row-attach-files/' + JSON.stringify(this.header), {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(item)
                });
                const result = await response.json();
                if ((response.status === 200) && (result.result === 'success')) {
                    this.makeToast('success', this.setText('message'), this.setText('record_delete'));
                    // await this.saveTotal();
                }
            } catch {
                this.makeToast('danger', this.setText('warning'), this.setText('errors.del_data'));
            }
        }, // удаление данных
        infoModule(info_id, file) {
            const that = this;
            Ax(
                {
                    url: '/api-py/get-info/' + info_id, //  Тело файла
                    method: 'POST',
                    data: null,
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file + '.pdf');// or any other extension
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    this.makeToast(this, 'danger', this.setText('errors.download'), error.toString());
                }
            );
        },
        async loadParent(parent) {
            try {
                let level = 'abp';
                if (this.tabIndex === 1)  {
                    level = 'abp'
                } else if (this.tabIndex === 2 || this.tabIndex === 3) {
                    level = 'uf';
                }
                const response = await fetch(`api/budget-execution-alteration-${level}-request?requestId=${parent.parent}`);
                if (response.status === 200) {
                    const currentParent = await response.json();
                    this.$set(parent, 'parentInfo', currentParent);
                }
            } catch (error) {
                this.makeToast('danger', this.setText('errors.consolidation'), error.toString());
            }
        },
        onReLoad(val) {
            this.$emit('reLoad', val);
        },
        copyId(id) {
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(id).then(() => {
                    this.makeToast('success', this.setText('success'), this.setText('id_copied') + id);
                });
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = id;
                textArea.style.position = "fixed";
                textArea.style.left = "-999999px";
                textArea.style.top = "-999999px";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                try {
                    document.execCommand('copy');
                    this.makeToast('success', this.setText('success'), this.setText('id_copied') + id);
                } catch (error) {
                    console.error(this.setText('copy_error'), error);
                    this.makeToast('danger', this.setText('errors.err'), this.setText('id_not_copied'));
                }
                textArea.remove();
            }
        },
        downloadVerifyReport(val){
            const that = this;
            let name = 'без ГУ'
            let name_kk = 'ММсіз'
            if (val === 1) {
                name = 'с ГУ'
                name_kk = 'ММ-мен'
            }
            const params = JSON.stringify({
                dateTo: this.verifyReport['dateTo'],
                dateFrom: this.verifyReport['dateFrom'],
                selectedAlteration: this.verifyReport['selectedAlteration'],
                selectedStatus: this.verifyReport['selectedStatus'],
                locale: this.$i18n.locale,
                repType: val,
                user_id: this.userUiid,
                region: this.verifyReport['region'],
                gu261: this.verifyReport['gu261'],
                guDate: this.verifyReport['guDate']
            });
            Ax(
                {
                    url: '/api-py/download-verify-report/' +  encodeURI(params), //  Тело файла
                    method: 'POST',
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    switch (this.$i18n.locale) {
                        case 'kk':
                            link.setAttribute('download', 'Білім басқармасы/бөлімі үшін тексеру есебі (' + name_kk + ').xls');// or any other extension
                            break;
                        default:
                            link.setAttribute('download', 'Проверочный отчет для Управления/Отдела образования (' + name + ').xls');// or any other extension
                    }
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    that.error = error;
                }
            );
        },
        async openHistory(agrObj) {
            if (agrObj !== null) {
                await this.$refs.refHistModal.showEvent(agrObj);
            }
        },
        async loadApplicationsTitle() {
            if (!this.selectedAlteration) return;

            try {
                const date = new Date(this.selectedAlteration.date).toISOString().split('T')[0];
                const response = await axios.get(`/api-py/alteration_applications-list/${date}`);
                this.appsList = response.data || [];
            } catch (error) {
                console.error('Ошибка при загрузке списка приложений', error);
                this.makeToast('danger', 'Ошибка', 'Не удалось загрузить список приложений');
            }
        },
        appText(app) {
            switch (`${i18nService.locale}`) {
                case 'ru':
                    return `${app.name_ru} ${app.full_name_ru}`
                case 'kk':
                    return `${app.name_kz} ${app.full_name_kz}`
                case 'en':
                    return `${app.name_ru} ${app.full_name_ru}`
                default:
                    break;
            }
        },
        canEditBasisField(item) {
            // При редактировании проверяем статус и консолидацию
            if (item && item.status) {
                // Статус "Согласовано УО" (32) или статус 52
                const isApprovedByUO = item.status.status === 32;
                // Проверяем, сконсолидирована ли заявка (наличие поля parent)
                const isConsolidated = item.parent !== null;

                // Разрешаем редактирование поля "Основание" если заявка в статусе "Согласовано УО" (32) и сконсолидирована
                return !(isApprovedByUO && isConsolidated);
            }
            return true;
        },
        haveEditAccessAbp(item) {
            if (item && item.status && item.status.status === 32 && item.parent !== null) {
                return ['abp'].includes(this.accessLevels.position);
            }
            return true;
        },
    },
    mounted () {
        document.addEventListener('click', this.hidePopover);
    },
    beforeDestroy () {
        document.removeEventListener('click', this.hidePopover);
        if (this.hidePopoverTimer) {
            clearTimeout(this.hidePopoverTimer);
        }
    },
    computed: {
        isAbp123() {
            return Array.isArray(this.requestsBase) && this.requestsBase.some(item => String(item.abp) === '123');
        },
        userUiid () {
            if (store.state.user.sub) {
                return store.state.user.sub;
            }
            return null;
        },
        filteredApps() {
            const s = this.selectedAlteration;
            const m = this.accessLevels?.modules;
            const p = this.accessLevels?.position;
            const t = this.activeTab;

            const rules = {
                9: () => s && m==='005.002.008' && !t,
                10: () => s && m==='005.002.008' && !t,
                20: () => m==='005.002.002' && !t,
                21: () => m==='005.002.002' && !t,
                1: () => s && m==='005.002.001' && t==='uf',
                2: () => s && m==='005.002.001' && t==='uf',
                5: () => s && m==='005.002.003' && (p==='abp' || p==='uf' || p===''),
                11: () => s && m==='005.002.003' && (p==='abp' || p==='uf' || p===''),
                6: () => s && m==='005.002.003' && (p==='abp' || p==='uf' || p===''),
                12: () => s && m==='005.002.003' && (p==='abp' || p==='uf' || p===''),
                15: () => s && m==='005.002.001' && t==='uf',
                3: () => s && (
                    (m==='005.002.001' && p==='abp') ||
                    (m==='005.002.003' && (p==='abp' || p==='uf' || p==='') && t==='abp') ||
                    (m==='005.002.007' && p==='abp')
                ),
                13: () => s && (
                    (m==='005.002.001' && p==='abp' && t==='ipf') ||
                    (m==='005.002.003' && (p==='abp' || p==='uf' || p==='') && t==='abp') ||
                    (m==='005.002.007' && p==='abp')
                ),
                16: () => s && m==='005.002.001' && t==='uf',
                4: () => s && (
                    (m==='005.002.001' && p==='abp') ||
                    (m==='005.002.003' && (p==='abp' || p==='uf' || p==='') && t==='abp') ||
                    (m==='005.002.007' && p==='abp')
                ),
                14: () => s && (
                    (m==='005.002.001' && p==='abp' && t==='ipf') ||
                    (m==='005.002.003' && (p==='abp' || p==='uf' || p==='') && t==='abp') ||
                    (m==='005.002.007' && p==='abp')
                ),
                // Приложение 36 (по учреждениям) — видимость идентична id=3 (FPR34)
                24: () => s && (
                    (m==='005.002.001' && p==='abp') ||
                    (m==='005.002.003' && (p==='abp' || p==='uf' || p==='') && t==='abp') ||
                    (m==='005.002.007' && p==='abp')
                ),
                // Приложение 38 (по учреждениям) — видимость идентична id=4 (FPR36)
                25: () => s && (
                    (m==='005.002.001' && p==='abp') ||
                    (m==='005.002.003' && (p==='abp' || p==='uf' || p==='') && t==='abp') ||
                    (m==='005.002.007' && p==='abp')
                ),
                7: () => s && m==='005.002.002' && t==='uf',
                8: () => s && m==='005.002.002' && t==='uf',
                17: () => s && m==='005.002.002' && t==='uf',
                19: () => s && m==='005.002.002' && t==='uf',
                22: () => s && m==='005.002.002' && t==='uf',
                23: () => s && m==='005.002.002' && t==='uf',
            };

            return (this.appsList || []).filter(app => rules[app.id]?.());
        }
    },
    watch: {
        "requestsBase": function (val) {
            this.checkCount = 0;
            this.checkVisible = false;
            val.forEach(item => {
                if (item.checking === true) {
                    this.checkCount += 1;
                    this.checkVisible = true;
                }
            });
            this.selectAll = false;
        }
    },
    async created () {
        await this.setUserRole()
    },
    filters: {
        formatDate: function (value) {
            if (value) {
                return moment(value).format('DD.MM.YYYY')
            }
            return null;
        }
    }
};
</script>


<style lang="scss" scoped>
.doc-icon {
    margin-right: 5px;
}

.selected_row {
    background-color: #86cfda;
}

.icon-btn{
    width: 20px;
    height: 20px;
    padding: 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: none !important;
    background-color: transparent;
    border: 1px solid rgba(28, 42, 62, 1);
    border-radius: 50%;
    margin: 0;
}
.icon-btn i{
    font-size: 0.4444444444rem;
    color: rgba(28, 42, 62, 1);
}
.duplicate-button{
    position: absolute;
    z-index: 2;
    top: 5px;
    right: 20px;
}
</style>